import { analyticsIds } from '../../../../../constants/analyticsIds';
import { CodeActions, CodeStatuses } from '../../../../../constants/codes';

export const handleCheckboxChange = (onChange, itemCodeStatus, codeId, letter) => () => {
  switch (itemCodeStatus || null) {
    case CodeStatuses.Suggested: {
      return onChange(CodeActions.Clear, codeId, letter);
    }

    case null:
    case CodeStatuses.Default:
    case CodeStatuses.Removed: {
      return onChange(CodeActions.Suggest, codeId, letter);
    }

    case CodeStatuses.Applied: {
      return onChange(CodeActions.SuggestRemoval, codeId, letter);
    }
    default: {
      // do nothing
      return null;
    }
  }
};

export const handleAuditApproval = (onChange, itemCodeStatus, codeId, letter) => () => {
  switch (itemCodeStatus) {
    case CodeStatuses.Inquiring:
    case CodeStatuses.Suggested: {
      return onChange(CodeActions.Apply, codeId, letter);
    }

    case CodeStatuses.RemovalSuggested: {
      return onChange(CodeActions.Clear, codeId, letter);
    }

    default: {
      // do nothing
      return null;
    }
  }
};

export const handleAuditRejection = (onChange, itemCodeStatus, codeId, letter) => () => {
  switch (itemCodeStatus) {
    case CodeStatuses.Suggested: {
      return onChange(CodeActions.Clear, codeId, letter);
    }

    case CodeStatuses.RemovalSuggested: {
      return onChange(CodeActions.Apply, codeId, letter);
    }

    default: {
      // do nothing
      return null;
    }
  }
};

export const handleWaveClick = (onChange, itemCodeStatus, codeId, letter) => () => {
  switch (itemCodeStatus) {
    case CodeStatuses.Default:
    case CodeStatuses.Suggested:
    case CodeStatuses.Removed: {
      // do nothing
      return null;
    }

    case CodeStatuses.Waived: {
      return onChange(CodeActions.Apply, codeId, letter);
    }

    default: {
      return onChange(CodeActions.Waive, codeId, letter);
    }
  }
};

export const handleInquireClick = (onChange, itemCodeStatus, codeId, letter) => () => {
  switch (itemCodeStatus) {
    case CodeStatuses.Default:
    case CodeStatuses.Suggested:
    case CodeStatuses.Removed: {
      // do nothing
      return null;
    }

    case CodeStatuses.Inquiring: {
      return onChange(CodeActions.Apply, codeId, letter);
    }

    default: {
      return onChange(CodeActions.Inquire, codeId, letter);
    }
  }
};

export const getCheckboxAnalyticsId = status => {
  switch (status || null) {
    case CodeStatuses.Suggested:
      return analyticsIds.insuredProfilePage.itemsComponent.clearCode;

    case null:
    case CodeStatuses.Default:
    case CodeStatuses.Removed:
      return analyticsIds.insuredProfilePage.itemsComponent.suggestApplyCode;

    case CodeStatuses.Applied:
      return analyticsIds.insuredProfilePage.itemsComponent.suggestClearCode;

    default:
      return '';
  }
};

export const getAuditApprovalAnalyticsId = status => {
  switch (status) {
    case CodeStatuses.Suggested:
    case CodeStatuses.Inquiring:
      return analyticsIds.insuredProfilePage.itemsComponent.applyCode;

    case CodeStatuses.RemovalSuggested: {
      return analyticsIds.insuredProfilePage.itemsComponent.clearCode;
    }

    default:
      return '';
  }
};

export const getAuditRejectionAnalyticsId = status => {
  switch (status) {
    case CodeStatuses.Suggested:
      return analyticsIds.insuredProfilePage.itemsComponent.clearCode;

    case CodeStatuses.RemovalSuggested:
      return analyticsIds.insuredProfilePage.itemsComponent.applyCode;

    default:
      return '';
  }
};

export const getWaiveAnalyticsId = status => {
  switch (status) {
    case CodeStatuses.Default:
    case CodeStatuses.Suggested:
    case CodeStatuses.Removed:
      return '';

    case CodeStatuses.Waived:
      return analyticsIds.insuredProfilePage.itemsComponent.applyCode;

    default:
      return analyticsIds.insuredProfilePage.itemsComponent.waiveCode;
  }
};

export const getInquireAnalyticsId = status => {
  switch (status) {
    case CodeStatuses.Default:
    case CodeStatuses.Suggested:
    case CodeStatuses.Removed:
      return '';

    case CodeStatuses.Inquiring:
      return analyticsIds.insuredProfilePage.itemsComponent.applyCode;

    default:
      return analyticsIds.insuredProfilePage.itemsComponent.applyExceptionCode;
  }
};
